module.exports = __webpack_public_path__ + "routes/notFound/lamington_sad.png?98da192b";


//////////////////
// WEBPACK FOOTER
// ./routes/notFound/lamington_sad.png
// module id = 2349
// module chunks = 0